import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Tag, TagsRoot } from './Tags.styles'

type TagsProps = {
  tags: { name: string; sys: { id: string } }[]
  activeTags: string[]
  onChange: (tags: string[]) => void
}

export const Tags = ({ tags, activeTags, onChange }: TagsProps) => {
  const { t } = useTranslation()

  const toggleTag = (tagId: string) => {
    const updatedTags = activeTags.includes(tagId)
      ? activeTags.filter((id) => id !== tagId)
      : [...activeTags, tagId]

    onChange(updatedTags)
  }

  const resetTags = () => onChange([])

  return (
    <TagsRoot justifyContent="center" alignItems="center" gap="0">
      <Tag onClick={() => resetTags()} isActive={activeTags.length === 0}>
        <Text size="headline" weight="bold" align="center">
          {t('blog:tags.all')}
        </Text>
      </Tag>

      {tags.map((tag) => {
        return (
          <Tag
            key={tag.sys.id}
            onClick={() => toggleTag(tag.sys.id)}
            isActive={activeTags.includes(tag.sys.id)}
          >
            <Text size="headline" weight="bold" align="center">
              {tag.name}
            </Text>
          </Tag>
        )
      })}
    </TagsRoot>
  )
}
